/*eslint-disable*/
// eslint-disable-next-line no-unused-vars

import {
  postRequest,
  postRequestParams,
  getRequest,
  deleteRequest,
  postDataParams

} from '@/api/request'; // 导入request中创建的axios实例
const baseMsg = {
  //获取公司信息
  company: {
    //获取公司信息
    Detail: (params) => {
      return getRequest('base/org/getOrg', params)
    },
  },

  //获取字典信息
  dictBox: {
    org: (params) => { //机构信息
      return getRequest('base/org/orgComboBox', params)
    },
    deptList: (params) => { //机构信息
      return getRequest('base/dept/comboBox', params)
    },
    dictList: (params) => { //字典信息
      return getRequest('base/dictionary/itemList', params)
    },
    //字典项列表（启用）
    enableItemList: (parentCode) => {
      return getRequest('base/dictionary/itemSelectList/' + '?parentCode=' + parentCode, {})
    },
    staffPageList: (pageNum, pageSize, params) => { //人员管理列表
      return postRequest('base/staff/info/staffPageList/' + pageNum + '/' + pageSize, params)
    },
    projectSelectList: (params, data) => { //项目选择列表
      //公共-查询项目列表接口-谢明
      return postDataParams("app/project/info/projectSelectList", params, data);
    },
    commonProject: (params, data) => { //项目列表
      //公共-查询项目列表接口-谢明
      return postDataParams("app/project/info/commonProject", params, data);
    },
    projectList: (params, data) => { //项目列表
      //app端-项目列表查询-谢明
      return postDataParams("app/project/info/projectList", params, data);
    },
    myJoinProject: (params, data) => { //App端-查询我正在参与的项目列表接口-谢明
      return postRequestParams("app/project/info/myJoinProject", params, data);
    },
    commonBiddingList: (params, data) => { //公共-投标列表选项接口-谢明
      //公共-投标列表选项接口-谢明
      return postDataParams("app/bidding/commonBiddingList", params, data);
    },
    sealList: (params) => { //印章列表
      return getRequest('material/materialOfficeSeal/materialOfficeSealList', params)
    },

    contractList: (params) => { //公共-合同列表选项接口-谢明
      return getRequest('app/contract/contractList', params)
    },
    commonContract: (params) => { //我参与的合同列表选项接口-谢明
      return postRequestParams('app/contract/commonContract', params)
    },
  },

  getCommentList: (mode,id) => { //评论列表查询接口-肖东
    
    return mode == "keepRecord" ?
    getRequest("app/note/noteCommentList/"+id, {}) //记事评论列表查询接口-肖东
    :
    getRequest('app/notice/getNoticeCommentList/' + id, {}); //通知评论列表查询接口-肖东
   
  },
  setCommentList: params => { //评论列表查询接口-肖东  
    return postRequest('app/notice/addNoticeComment', params); //通知评论新增接口-肖东
  },
  //机构岗位列表
  getPostList: (params) => { //机构岗位下拉选择接口-陈国贵
    return getRequest('base/post/comboBoxList', params)
  },
  
//部门下拉列表接口
  getDeptList: (params) => { //部门下拉列表接口-陈国贵
    return getRequest('base/dept/comboBox', params)
  },
  //部门经理人员选择-陈国贵
  deptManagerList: (pageNum,pageSize,params) => { //部门下拉列表接口-陈国贵
    return postRequest('base/staff/info/deptManagerList/' + pageNum + '/' + pageSize, params)
  },
};
const Msg = {
  infoMsg: (params) => { //通知信息详情
    return getRequest('app/notice/getNoticeInfoDetails', params)
  },
 
  infoRead: params => { //通知阅读接口-张涛山
    return postRequest('app/staff/noticeRead',params)
  },
};
const Dinner = {
  dinnerList:  (pageNum, pageSize, params) => { //人员管理列表
    return getRequest('app/orderFood/orderFoodList/' + pageNum + '/' + pageSize, params)
  },
 
  
};

export default {
  baseMsg,
  Msg,
  Dinner
};